/* eslint-disable */

import React, {useRef, useState} from 'react';

import {useSetRecoilState, useRecoilValue} from 'recoil';
import {setActivitiesState, langState} from '../state/activities';
import {readAllFiles} from '../utils/readAllFiles';
import {useNavigate} from 'react-router-dom';
import UIButton from '../components/UICommon/UIButton';
import {default as text} from '../translate/lang.json'

const pdfIcon = require('../assets/load-pdf.png');

const PageOverview = () => {
  const [files, setFiles] = useState<any>([]);
  const [fileName, setFileName] = useState('');
  const setActivities = useSetRecoilState(setActivitiesState);
  const inputRef = useRef<HTMLInputElement>(null);
  const navigate = useNavigate();
  const lang = useRecoilValue(langState);

  const loadFiles = (ref: React.RefObject<HTMLInputElement>) => {
    const filesArray = Array.from(ref.current!.files as ArrayLike<File>);
    //setFileName(filesArray[0].name);
    const files = readAllFiles(filesArray);
    files.then(function(result) {
      setFiles(result);
    }).catch(function() {
      alert('Error.');
    });
  };

  const handleClick = () => {
    setActivities(files);
    navigate('/aktiviteter/');
  };
  const navHelp = () => {
    navigate('/help/');
  };

  return (
    <div className="flex flex-col items-center gap-6 py-8 px-4 max-w-2xl mx-auto">
      {/* Upload card */}
      <div className="w-full bg-white rounded-2xl shadow-sm border border-gray-200 p-8 flex flex-col items-center">
        <h2 className="font-bold text-black-accent text-2xl mb-2 text-center">
          {text.start_title[lang]}
        </h2>
        <p className="text-sm text-gray-500 text-center max-w-md mb-6 leading-relaxed">
          {text.start_description[lang]}
        </p>

        <div className="group flex flex-col w-full max-w-sm h-52 border-2 border-dashed border-gray-300 rounded-xl items-center justify-center relative hover:border-main-blue hover:bg-blue-50/30 transition-all duration-200 cursor-pointer mb-6">
          <img className="mb-3 w-12 h-12 opacity-60 group-hover:opacity-80 transition-opacity" src={pdfIcon} alt="UPLOAD" />
          <span className="text-xs text-gray-500 text-center px-6 leading-relaxed">
            {text.start_details[lang]}
          </span>
          {fileName && (
            <span className="text-xs text-main-blue font-medium mt-2">{fileName}</span>
          )}
          <input
            className="opacity-0 absolute inset-0 cursor-pointer"
            ref={inputRef}
            name="fileInput"
            type="file"
            accept='.json'
            onChange={() => loadFiles(inputRef)}
            multiple
          />
        </div>

        <UIButton
          text={text.start_button[lang]}
          handleClick={handleClick}
        />
      </div>

      {/* Help card */}
      <div className="w-full bg-white rounded-2xl shadow-sm border border-gray-200 p-6 flex items-center gap-5">
        <div className="flex-shrink-0 w-10 h-10 rounded-full bg-main-blue/10 flex items-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-main-blue" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <p className="text-sm text-gray-600 flex-grow leading-relaxed">
          {text.start_help_desc[lang]}
        </p>
        <button
          onClick={navHelp}
          className="flex-shrink-0 text-sm font-semibold text-main-blue hover:text-main-blue/80 transition-colors"
        >
          {text.start_help[lang]} →
        </button>
      </div>
    </div>
  );
};

export default PageOverview;
